import Keycloak from 'keycloak-js';
import { environment } from 'src/environments/environment';

export const keycloak = new Keycloak({
    url: environment.keycloakUrl,
    realm: 'sc-mb',
    clientId: 'sc-mb-panel',
});

export enum TypeUser {
    ADMIN = 'admin',
    CLIENT = 'client',
}

export async function initializeKeycloak(): Promise<TypeUser | undefined> {
    try {
        const authenticated = await keycloak.init({
            onLoad: 'login-required',
            pkceMethod: 'S256',
            checkLoginIframe: false,
        });
        if (!authenticated) {
            await keycloak.login();
        }

        const realRealmName = keycloak.tokenParsed?.['real-realm-name'];

        if (realRealmName === TypeUser.ADMIN) {
            return TypeUser.ADMIN;
        } else if (realRealmName === TypeUser.CLIENT) {
            return TypeUser.CLIENT;
        }
    } catch (err) {
        console.error('Error initializing Keycloak', err);
        return undefined;
    }
}

export default keycloak;
